import { put, takeLatest } from 'redux-saga/effects';
import { PersonalTask, PersonalTaskAPI } from 'api/personal-tasks';
import { logger } from 'services';
import { createStart, create, createSuccess, createFailure } from '..';
import { StoreActionProps } from '../../core';
import { createPersonalTaskSagaAction } from '../actions';

function* createPersonalTaskSaga(
  action: StoreActionProps<Partial<PersonalTask>>,
) {
  const { payload } = action;

  try {
    yield put(createStart());
    const data = (yield PersonalTaskAPI.createPersonalTask(
      payload,
    )) as PersonalTask;

    yield put(create(data));
    yield put(createSuccess());
  } catch (error) {
    logger.error('createPersonalTask failed', { error });
    yield put(createFailure());
  }
}

export function* watchCreatePersonalTaskSaga(): Generator {
  yield takeLatest(createPersonalTaskSagaAction.type, createPersonalTaskSaga);
}
